const { centsPerDollar } = require('../constants/currency');

/**
 * @param {number} cents
 * @returns {number}
 */
function convertCentsToDollars(cents) {
	return cents / centsPerDollar;
}

/**
 * @param {number} dollars
 * @returns {number}
 */
function convertDollarsToCents(dollars) {
	return dollars * centsPerDollar;
}

/**
 * @param {number} number
 * @param {string=} locale
 * @param {string=} currency
 * @returns {string}
 */
function convertNumberToCurrencyString(
	number,
	locale = 'en-US',
	currency = 'USD'
) {
	return Number(number).toLocaleString(locale, {
		currency,
		maximumFractionDigits: 0,
		minimumFractionDigits: 0,
		style: 'currency',
	});
}

module.exports = {
	convertCentsToDollars,
	convertDollarsToCents,
	convertNumberToCurrencyString,
};
